import { textStylesSelector } from "./textStyleSelector";
import { retrieveContentfulImage } from "../common/image";

export const getNumberedtitleTextImageData = (componentData) => {
    const { titleStyle } = textStylesSelector(componentData);

    const data = {};
    data.bgColor = componentData?.fields?.backgroundColour;
    data.titleNumber = componentData?.fields?.extraParameters?.[0];
    data.title = componentData?.fields?.title;
    data.titleStyle = titleStyle?.fields;
    data.description = componentData?.fields.elements?.[0]?.fields?.description;
    if (componentData?.fields.elements?.[0]?.fields?.image) {
        data.imageUrl = retrieveContentfulImage(componentData?.fields.elements?.[0]?.fields?.image?.fields?.file?.url);
        data.imageTitle = componentData?.fields.elements?.[0]?.fields?.image?.fields?.title;
        data.imageDescription = componentData?.fields.elements?.[0]?.fields?.image?.fields?.description;
    }

    return data;
};